import {environmentConfiguration} from './environment';
import {configuration as frameworkConfiguration} from '@zvne/fe-framework/dist/configuration/configuration';

export interface EnvironmentConfiguration {
    environment: string;
    apiRoot: string;
    geoserverRoot: string,
    geoserverLayerPrefix: string;
    keycloakUrl: string;
    keycloakRealm: string;
    keycloakClientId: string;
}

export const configuration = {
    ...frameworkConfiguration,
    ...environmentConfiguration
};
